import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTabsComponent} from "./int-tabs.component";
import {IntTabsActionDirective} from "./int-tabs-action.directive";
import {IntTabsContentDirective} from "./int-tabs-content.directive";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntTabsComponent,
    IntTabsActionDirective,
    IntTabsContentDirective
  ],
  exports: [
    IntTabsComponent,
    IntTabsActionDirective,
    IntTabsContentDirective
  ]
})
export class IntTabsModule {}
